import { render, staticRenderFns } from "./RedeImob.vue?vue&type=template&id=70caf0ba&scoped=true&"
import script from "./redeImob.js?vue&type=script&lang=js&"
export * from "./redeImob.js?vue&type=script&lang=js&"
import style0 from "./RedeImob.vue?vue&type=style&index=0&id=70caf0ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70caf0ba",
  null
  
)

export default component.exports